// extracted by mini-css-extract-plugin
module.exports = {"container":"PinCheckbox_container__dtRLb","pin":"PinCheckbox_pin__koIPF","pinned":"PinCheckbox_pinned__1jhh5"};